import React, { useEffect, useRef, useState } from 'react';
import {
	ChartWrapper,
	TitleSection,
	TopContentWrapper,
	Wrapper,
} from '../shared.styles';
import { useRequestsContext } from '@/common/hooks/requestHook';
import CustomSkeleton from '@/common/components/CustomSkeleton';
import Input from '@/common/components/Input';
import CustomLine from '@/common/charts/Line';
import { handleMapData } from './helpers/handleMapData';
import { getLastMarketWPPK } from '@/API/repositories/reports';
import { useCommonDataContext } from '@/common/hooks/commonDataContext';
import Icon from '@/common/components/Icon';
import { useMessageQueueContext } from '@/common/hooks/useMessageQueue';
import { PRODUCT_CHART_WRAPPER_HEIGHT } from '../../constants/productStatusOptions';
import { applyWppkProductSelection } from '../../helpers/applyWppkProductSelection';
import { useProductChartFilters } from '../../hooks/useProductChartFilters';
import ProductChartFilters from '../productChartFilters/ProductChartFilters';
import ProductChartActions from '../productChartFilters/ProductChartActions';

const WppkConfirmedMarket = () => {
	const [chartData, setChartData] = useState();
	const [rawData, setRawData] = useState();
	const timeRangeRef = useRef();

	const {
		commonData: { products },
	} = useCommonDataContext();
	const { makeRequest } = useRequestsContext();
	const { addMessage } = useMessageQueueContext();
	const {
		productStatus,
		setProductStatus,
		selectedProducts,
		setSelectedProducts,
		productOptions,
		handleSelectAll,
		handleUnselectAll,
	} = useProductChartFilters(products);

	const handleLoadData = async () => {
		setChartData(() => null);
		setRawData(() => null);

		const payload = {};
		payload.timeFrom = timeRangeRef.current.value;
		payload.timeTo = 0;

		const response = await makeRequest(getLastMarketWPPK.bind(null, payload));

		if (!response?.data) {
			addMessage('Something went wrong', 'error');
			return;
		}

		const sortedData = [...response.data].sort(
			(a, b) => new Date(a.from).getTime() - new Date(b.from).getTime(),
		);

		setRawData(() => sortedData);
	};

	useEffect(() => {
		if (products) {
			handleLoadData();
		}
	}, [products]);

	useEffect(() => {
		applyWppkProductSelection({
			rawData,
			selectedProducts,
			products,
			setChartData,
			mapData: handleMapData,
		});
	}, [rawData, selectedProducts, products]);

	return (
		<Wrapper width={800} height={PRODUCT_CHART_WRAPPER_HEIGHT}>
			<TitleSection>
				<TopContentWrapper>
					<Icon name='usps' size={20} />
					Weekly product WPPK confirmed
				</TopContentWrapper>
				<TopContentWrapper>
					<Input
						showLabel={false}
						inputWidth={50}
						value={0}
						inputRef={timeRangeRef}
					/>
					<Icon
						name='arrows-rotate'
						style={{ cursor: 'pointer' }}
						onClick={() => handleLoadData()}
					/>
				</TopContentWrapper>
			</TitleSection>
			<ProductChartFilters
				productStatus={productStatus}
				setProductStatus={setProductStatus}
				productOptions={productOptions}
				selectedProducts={selectedProducts}
				setSelectedProducts={setSelectedProducts}
			/>
			<ChartWrapper>
				{chartData ? (
					<CustomLine
						data={chartData}
						options={{
							scales: {
								y: {
									type: 'linear',
									display: true,
									position: 'left',
								},
							},
						}}
					/>
				) : (
					<CustomSkeleton width={750} count={16} height={5} />
				)}
			</ChartWrapper>
			<ProductChartActions
				handleSelectAll={handleSelectAll}
				handleUnselectAll={handleUnselectAll}
			/>
		</Wrapper>
	);
};

export default WppkConfirmedMarket;
